// extracted by mini-css-extract-plugin
module.exports =  {"root":"w9EqgUkzBR5ShA0KDfGm","prefix":"GR1q8bqRBv0NDP9syWcA"};